import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {AlertaService} from '../../../../../shared/services/alerta.service';
import {VnaCampaignService} from '../../../vna-campaign/services/vna-campaign.service';
import {PortalService} from '../../../vna_portal/model/PortalService';

@Component({
  selector: 'app-cache-config',
  templateUrl: './cache-config.component.html',
  styleUrls: ['./cache-config.component.scss']
})
export class CacheConfigComponent implements OnInit {

    @Input() portalService: PortalService;

    form: FormGroup;
    enabled: boolean = false;
    submitted: boolean = false;

    constructor(private fb: FormBuilder, private campHandler: VnaCampaignService, private alertHandler: AlertaService) {
        this.form = this.fb.group({
            camp_use_cache: new FormControl('1'),
            camp_cache_max_age_days: new FormControl(),
            camp_cache_type: new FormControl()
        });
    }

    save(): void {
        this.submitted = false;

        if(!this.form.valid){
            this.submitted = true;
            return;
        }

        this.enabled = true;
        let criteria = { 'portal_pk' : this.portalService.pkPortal, 'service_pk' : this.portalService.pkService, 'camp_pk' : this.portalService.pkCamp };

        this
            .campHandler
            .savePortalService(criteria, 'cache_parameters', this.portalService.alias, this.form.value)
            .subscribe( result =>{
                this.enabled = false;
                this.alertHandler.addAlert('success','Cache configuration have been saved successfully')
            })

    }

    ngOnInit() {
        this.form.controls['camp_use_cache'].setValue(this.portalService.getConfigKey('camp_use_cache', '1'));
        this.form.controls['camp_cache_max_age_days'].setValue(this.portalService.getConfigKey('camp_cache_max_age_days', ''));
        this.form.controls['camp_cache_type'].setValue(this.portalService.getConfigKey('camp_cache_type', ''));
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/cache-config/cache-config.component.ts